// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M12 6L8 10L4 6'];
